import axios from 'axios'
import { stringify } from 'query-string'
import { ConfigResponse } from 'src/models/config.models'
import { getResponseData } from 'src/queries/network.utils'
import { getRequestConfig, RequestConfig } from 'src/queries/requestConfig'

/**
 * Fetches the localized signup/session reference config (department, industry,
 * team-size, referral-source option lists plus supported locales/currencies).
 *
 * Request config: the legacy `getConfig` thunk used
 * `selectUnauthedFormApiRequestConfig`. `RequestConfig.Unauthed` is the
 * matching variant — `/config` must work pre-auth (signin/register pages).
 * The only delta is the Content-Type header (json vs multipart/form-data),
 * which is inert on this body-less GET.
 */
export const getSessionConfig = async (
  locale: string,
): Promise<ConfigResponse> => {
  return getResponseData(
    axios.get<ConfigResponse>(
      `/config?${stringify({ locale })}`,
      getRequestConfig(RequestConfig.Unauthed),
    ),
  )
}
